import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {Col} from 'react-flexbox-grid'
import {getPlaceholderText} from './placeholder-text';

import { STATUS } from "state/requestStatus/reducer";
import VotePrefControls from 'components/interactive/votePref/VotePrefControls';
import VotePrefReader from 'components/interactive/votePref/VotePrefReader';
import VotePrefEditor from 'components/interactive/votePref/VotePrefEditor';
// import VotePrefSettings from 'components/interactive/votePref/VotePrefSettings';


class NoteContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditor: false,
    };
    this.placeholderText = getPlaceholderText();
  }

  toggleEdit = (event) => {
    this.setState({
      showEditor: !this.state.showEditor
    });
  }

  getVotePref = (props) => {
    const { votePrefs, pageId, authorUserId, loggedInUserId } = props;
    const userId = (authorUserId || loggedInUserId);
    const key = `${pageId}#${userId}`;
    const votePref = votePrefs[key] || { data: {} };
    return votePref;
  }

  componentWillReceiveProps(nextProps) {
    const votePref = this.getVotePref(nextProps);
    if (this.state.showEditor && (votePref.status === STATUS.COMPLETE)) {
      this.setState({
        showEditor: false
      });
    }
  }

  render() {
    const { pageId, authorUserId, loggedInUserId } = this.props;
    const votePref = this.getVotePref(this.props);
    const viewerIsOwner = loggedInUserId === authorUserId;
    const authorName = votePref.user ? votePref.user.name : null;
    const readerData = {
      onToggleEdit: this.toggleEdit,
      viewerIsOwner: viewerIsOwner,
      showEditor: this.state.showEditor,
      votePref: votePref,
      placeholderText: this.placeholderText,
    };

    //-- data to pass to the VotePrefControls component
    const controlData = {
      onToggleEdit: this.toggleEdit,
      showAnnotations: this.props.showAnnotations,
      viewerIsOwner: viewerIsOwner,
      authorUserId: authorUserId,
      loggedInUserId: loggedInUserId,
      pageId: pageId,
      shared: votePref.data.shared,
    };

    //-- data to pass to the VotePrefEditor component
    const editorData = {
      votePref: votePref,
      pageId: pageId,
      userId: loggedInUserId,
      onToggleEdit: this.toggleEdit,
      placeholderText: this.placeholderText,
    };

    // components
    let controls = null
    let readerOrEditor = null;

    // client is on pure URL and not logged in
    if (!authorUserId && !loggedInUserId) {
      //console.log("client is on pure URL and not logged in");
      readerOrEditor = <VotePrefEditor
        title="Write notes and share them"
        options={["login"]}
        data={editorData}
      />;
    }

    //-- client on sharedURL and is owner
    else if (authorUserId && (loggedInUserId === authorUserId)) {
      // console.log("client on sharedURL and is owner")
      readerOrEditor =
        !this.state.showEditor ?
        <VotePrefReader data={readerData}/>
        :
        <VotePrefEditor
          title="Editing my notes"
          options={["cancel","save"]}
          data={editorData}
        />
        controls = <VotePrefControls userNamePossessive="my" data={controlData} />;
    }

    //-- client is on pure URL and logged in
    else if (!authorUserId && loggedInUserId) {
      // console.log("client is on pure URL and logged in")

      controls = <VotePrefControls userNamePossessive="my" data={controlData}/>;
      //-- if votePref is empty, show them an editor
      if(!votePref.data.vote && !votePref.data.reason) {
        // console.log("no data in votePref, so showing editor")
        readerOrEditor =
          !this.state.showEditor ?
          <VotePrefReader data={readerData}/>
          :
          <VotePrefEditor
            title="Editing my notes"
            options= {["cancel","save"]}
            data={editorData}
          />
      }
      //-- if votePref is not empty, show them a reader
      else {
        // console.log("some data in votePref, so showing reader")
        readerOrEditor =
          !this.state.showEditor ?
          <VotePrefReader data={readerData}/>
          :
          <VotePrefEditor
            title="Editing my notes"
            options= {["cancel","save"]}
            data={editorData}
          />
      }

    }

    //-- client is on sharedURL and is not owner
    else if (authorUserId && (loggedInUserId !== authorUserId)) {
      // console.log("client is on sharedURL and is not owner")
      readerOrEditor = <VotePrefReader data={readerData}/>;
      controls = (
        <VotePrefControls
          userNamePossessive={`${authorName}'s`}
          data={controlData}
        />
      );
    }

    //-- client on pure URL and is logged in as owner
    //-- this case doesn't matter, should be same as pure URL and logged in.

    return (
      <React.Fragment>
        <Col
          xsOffset={0} xs={12}
          smOffset={2} sm={8}
          mdOffset={0} md={6}
          lgOffset={0} lg={6}
        >
          {readerOrEditor}
        </Col>
        <Col
          xsOffset={0} xs={12}
          smOffset={2} sm={8}
          mdOffset={0} md={3}
          lgOffset={0} lg={3}
        >
          {controls}
        </Col>
      </React.Fragment>
    );
  }
}

NoteContainer.contextTypes = {
  store: PropTypes.object
};

/*
  pageId is gotten from PropPage and {match.url}
  authorUserId is gotten from the URL, if there
  loggedInUserId is gotten from the store, if defined
  showAnnotations is the state of PropPage's
*/
NoteContainer.propTypes = {
  pageId: PropTypes.string.isRequired,
  authorUserId: PropTypes.string,
  loggedInUserId: PropTypes.string,
  showAnnotations: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  const user = state.user ? state.user.data : {};
  const { votePrefs } = state;
  return { user, votePrefs };
}

export default connect(mapStateToProps, {})(withRouter(NoteContainer));




// WEBPACK FOOTER //
// ./src/components/interactive/votePref/NoteContainer.js